import { CButton } from "@coreui/react";
import {useTranslation} from "react-i18next";
import classNames from "classnames";
import {FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";

export const AddButton = ({className, ...props}) => {
    
    const {t} = useTranslation("Buttons");
    
    return (
        <CButton type="button" color="info" size="sm" className={classNames(className)} {...props}><FontAwesomeIcon icon={faPlusCircle} className="mr-2"/>{t("add")}</CButton>
    );
};


export default AddButton;